import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var wrapIntoFragment = function wrapIntoFragment(children) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};